import _ from "lodash";
import {DefaultBtn} from "Ncontracts.Common.UI";
import PropTypes from "prop-types";
import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {
    discardNewCommunication,
    saveCommunicationDraft,
    selectRecipientsForEvent,
    sendNewCommunication
} from "../../../actions/communications/newCommunicationAction";
import isEmpty from "../../../helpers/isEmpty";
import initialState from "../../../reducers/communications/initialState";
import BubbleProgress from "../../common/BubbleProgress/BubbleProgress";

class NewCommunicationHeader extends Component {

    static propTypes = {
        discardNewCommunication: PropTypes.func,
        history: PropTypes.object,
        includesPoll: PropTypes.bool,
        isPosting: PropTypes.bool,
        match: PropTypes.object,
        message: PropTypes.string,
        pollOptions: PropTypes.arrayOf(PropTypes.string),
        pollQuestion: PropTypes.string,
        saveCommunicationDraft: PropTypes.func,
        selectedRecipients: PropTypes.array,
        selectRecipientsForEvent: PropTypes.func,
        sendNewCommunication: PropTypes.func,
        sendVoiceCalls: PropTypes.bool,
        title: PropTypes.string,
    };

    static defaultProps = {
        ...initialState
    };

    constructor(props, context) {
        super(props, context);
        this.state = {eventId: this.props.match.params.eventId};
        if (!isEmpty(this.state.eventId)) {
            this.props.selectRecipientsForEvent();
        }
    }

    getCurrentStep = () => {
        return isEmpty(this.props.match.params.currentStep) ? 'recipients' : this.props.match.params.currentStep;
    };

    isNextButtonDisabled = () => {
        const currentStep = this.getCurrentStep();
        const {message, title, selectedRecipients, includesPoll, pollQuestion, pollOptions} = this.props;

        if (currentStep === 'message' && !isEmpty(message) && !isEmpty(title)) {
            return false;
        }

        if (currentStep === 'recipients' && !isEmpty(selectedRecipients)) {
            return false;
        }

        if (currentStep === 'poll' && !includesPoll ||
            (!isEmpty(pollQuestion) && pollOptions.length > 1 && !pollOptions.filter(o => isEmpty(o)).length)) {
            return false;
        }

        return true;
    };

    goToRoot = (returnContext) => {
        if (returnContext === undefined || returnContext.returnUrl === undefined) {
            this.props.history.push('/communications');
        } else {
            this.props.history.push(returnContext.returnUrl);
        }
    };

    handlePrevClick = () => {
        let stepToGoTo = 'recipients';
        switch (this.getCurrentStep()) {
            case 'preview':
                stepToGoTo = 'poll';
                break;
            case 'poll':
                stepToGoTo = 'message';
                break;
        }
        this.props.history.push(`/communications/new/${stepToGoTo}`);
    };

    handleDiscardClick = () => {
        this.props.discardNewCommunication();
        this.goToRoot();
    };

    handleNextClick = () => {
        let stepToGoTo = 'preview';
        switch (this.getCurrentStep()) {
            case 'recipients':
                stepToGoTo = 'message';
                break;
            case 'message':
                stepToGoTo = 'poll';
                break;
        }
        this.props.history.push(`/communications/new/${stepToGoTo}`);
    };

    handleSendClick = () => {
        this.props.sendNewCommunication(this.generateNewCommunicationJSON());
    };

    handleSaveClick = () => {
        this.props.saveCommunicationDraft(this.generateNewCommunicationJSON());
    };

    generateNewCommunicationJSON = () => {
        return {
            contactDeterminers: this.props.selectedRecipients,
            messageText: this.props.message,
            sendVoiceCalls: this.props.sendVoiceCalls,
            title: this.props.title,
            includesPoll: this.props.includesPoll,
            pollQuestion: this.props.pollQuestion,
            pollOptions: this.props.pollOptions,
            eventId: this.state.eventId
        };
    }

    render() {
        const currentStep = this.getCurrentStep();

        const progressBar = <BubbleProgress pageArray={['Recipients', 'Message', 'Poll', 'Preview']}
                                            currentElement={_.startCase(currentStep)}/>;

        const prevButton = currentStep !== 'recipients' ? (
            <DefaultBtn className="btn--smaller" onClick={this.handlePrevClick}>Previous</DefaultBtn>
        ) : undefined;

        const discardButton = <DefaultBtn className="btn--base btn--smaller"
                                          onClick={this.handleDiscardClick}>Discard</DefaultBtn>;

        const nextButton = currentStep !== 'preview' ? (
            <DefaultBtn className="btn--smaller btn--solid"
                        disabled={this.isNextButtonDisabled()}
                        onClick={this.handleNextClick}>
                Next
            </DefaultBtn>
        ) : undefined;

        const sendButton = currentStep !== 'preview' ? undefined :
            <DefaultBtn className="btn--smaller btn--solid" disabled={this.props.isPosting}
                        onClick={this.handleSendClick}>Send</DefaultBtn>;

        const saveButton = currentStep !== 'preview' ? undefined :
            <DefaultBtn className="btn--smaller" disabled={this.props.isPosting}
                        onClick={this.handleSaveClick}>Save As Draft</DefaultBtn>;

        const rightSideButtons = <div className="prev-next-buttons">
            <div className="discard-button">
                {discardButton}
            </div>
            {saveButton !== undefined ? <div className="save-button">{saveButton}</div> : undefined}
            <div className="next-button">
                {nextButton !== undefined ? nextButton : sendButton !== undefined ? sendButton : <div/>}
            </div>
        </div>;

        return (
            <div className="page-header">
                <div className="columns is-mobile">
                    <div className="column">
                        {prevButton}
                    </div>
                    <div className="column">
                        {progressBar}
                    </div>
                    <div className="column">
                        {rightSideButtons}
                    </div>
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    includesPoll: state.newCommunication.includesPoll,
    isPosting: state.newCommunication.posting,
    message: state.newCommunication.message,
    pollOptions: state.newCommunication.pollOptions,
    pollQuestion: state.newCommunication.pollQuestion,
    selectedRecipients: state.newCommunication.selectedRecipients,
    sendVoiceCalls: state.newCommunication.sendVoiceCalls,
    title: state.newCommunication.title,
});

const mapDispatchToProps = dispatch => ({
    discardNewCommunication: () => dispatch(discardNewCommunication()),
    saveCommunicationDraft: communicationDraft => dispatch(saveCommunicationDraft(communicationDraft)),
    selectRecipientsForEvent: () => dispatch(selectRecipientsForEvent()),
    sendNewCommunication: newCommunication => dispatch(sendNewCommunication(newCommunication))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCommunicationHeader));
